import { useState, useEffect } from "react";
import { Gallery, Image } from "react-grid-gallery";
import Lightbox from "react-18-image-lightbox";
import Navbar from 'react-bootstrap/Navbar';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-18-image-lightbox/style.css";
import "./App.css";

export interface CustomImage extends Image {
  original: string;
}

export default function App() {
  const [index, setIndex] = useState(-1);
  const [cards, setCards] = useState([]);
  const [all, setAll] = useState([]);
  const [office, setOffice] = useState([]);
  const [shelf1, setShelf1] = useState([]);
  const [shelf2, setShelf2] = useState([]);
  const [shelf3, setShelf3] = useState([]);
  const [display, setDisplay] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("All");
  const [sort, setSort] = useState("Price");

  useEffect(() => {
    fetch('/cards.json')
    .then(function(u){ 
        return u.json();
    })
    .then(function(json) {
      setAll(json.data.cards.nodes);
      setCards(json.data.cards.nodes);
    });

    fetch('/office.json')
    .then(function(u){ 
        return u.json();
    })
    .then(function(json) {
      setOffice(json.data.cards.nodes);
    });

    fetch('/shelf_1.json')
    .then(function(u){ 
        return u.json();
    })
    .then(function(json) {
      setShelf1(json.data.cards.nodes);
    });

    fetch('/shelf_2.json')
    .then(function(u){ 
        return u.json();
    })
    .then(function(json) {
      setShelf2(json.data.cards.nodes);
    });

    fetch('/shelf_3.json')
    .then(function(u){ 
        return u.json();
    })
    .then(function(json) {
      setShelf3(json.data.cards.nodes);
    });

    fetch('/display.json')
    .then(function(u){ 
        return u.json();
    })
    .then(function(json) {
      setDisplay(json.data.cards.nodes);
    });
  }, []);

  const inFilter = (card: any) => {
    let filterSet: any = all;
    if (filter === "All") {
      filterSet = all;
    } else if (filter === "Office") {
      filterSet = office;
    } else if (filter === "Shelf 1") {
      filterSet = shelf1;
    } else if (filter === "Shelf 2") {
      filterSet = shelf2;
    } else if (filter === "Shelf 3") {
      filterSet = shelf3;
    } else if (filter === "Display") {
      filterSet = display;
    }

    for (let i = 0; i < filterSet.length; i++) {
      if (card.id === filterSet[i].id) {
        return true;
      }
    }

    return false;
  }

  const images: CustomImage[] = cards.filter((card: any) => {
    return (((card.sourceCard.cardSet.series.name + ": " + card.sourceCard.name + " (" + card.sourceCard.cardSet.name + ")").toLowerCase().includes(search.toLowerCase())) && inFilter(card));
  }).sort((a: any, b: any) => {
    if (sort === "Price") {
      return b.price - a.price;
    } else if (sort === "Alphabetical") {
      if (a.sourceCard.name === b.sourceCard.name) return 0;
      return (a.sourceCard.name > b.sourceCard.name ? 1 : -1);
    } else if (sort === "Date Added") {
      return 0
    } else  {
      return b.price - a.price;
    }
  }).map((card: any) => {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    return {
      src: card.cardImage[0].path,
      original: card.cardImage[0].path,
      width: 200,
      height: 270,
      caption: card.sourceCard.cardSet.series.name + ": " + card.sourceCard.name + " (" + card.sourceCard.cardSet.name + ") | " + formatter.format(card.price)
    }
  });

  const currentImage = images[index];
  const nextIndex = (index + 1) % images.length;
  const nextImage = images[nextIndex] || currentImage;
  const prevIndex = (index + images.length - 1) % images.length;
  const prevImage = images[prevIndex] || currentImage;

  const handleClick = (index: number, item: CustomImage) => setIndex(index);
  const handleClose = () => setIndex(-1);
  const handleMovePrev = () => setIndex(prevIndex);
  const handleMoveNext = () => setIndex(nextIndex);

  return (
    <div className="wrapper">
      {!currentImage && (
        <Navbar className="bg-body-tertiary justify-content-between" data-bs-theme="dark" sticky="top">
          <Form.Control
            type="text"
            placeholder="Search"
            className=""
            value={search}
            onChange={(event) => setSearch(event.target.value)}
          />
          <Button variant="link" style={{ textDecoration: 'none', color: 'var(--bs-body-color)' }} onClick={() => setSearch("")}>
            Clear
          </Button>
        </Navbar>
      )}
      <Gallery
        images={images}
        onClick={handleClick}
        enableImageSelection={false}
        rowHeight={270}
      />
      {!currentImage && (
        <Navbar className="bg-body-tertiary justify-content-between" data-bs-theme="dark" sticky="bottom">
          <DropdownButton variant="secondary" drop="up" title={"Filter: " + filter}>
            <Dropdown.Item onClick={() => { setFilter("All"); }}>All</Dropdown.Item>
            <Dropdown.Item onClick={() => { setFilter("Office"); }}>Office</Dropdown.Item>
            <Dropdown.Item onClick={() => { setFilter("Shelf 1"); }}>Shelf 1</Dropdown.Item>
            <Dropdown.Item onClick={() => { setFilter("Shelf 2");}}>Shelf 2</Dropdown.Item>
            <Dropdown.Item onClick={() => { setFilter("Shelf 3"); }}>Shelf 3</Dropdown.Item>
            <Dropdown.Item onClick={() => { setFilter("Display"); }}>Display</Dropdown.Item>
          </DropdownButton>
          <DropdownButton variant="secondary" drop="up" align="end" title={"Sort: " + sort}>
            <Dropdown.Item onClick={() => { setSort("Price"); }}>Price</Dropdown.Item>
            <Dropdown.Item onClick={() => { setSort("Alphabetical"); }}>Alphabetical</Dropdown.Item>
            <Dropdown.Item onClick={() => { setSort("Date Added"); }}>Date Added</Dropdown.Item>
          </DropdownButton>
        </Navbar>
      )}
      {!!currentImage && (
        /* @ts-ignore */
        <Lightbox
          mainSrc={currentImage.original}
          imageTitle={currentImage.caption}
          mainSrcThumbnail={currentImage.src}
          nextSrc={nextImage.original}
          nextSrcThumbnail={nextImage.src}
          prevSrc={prevImage.original}
          prevSrcThumbnail={prevImage.src}
          onCloseRequest={handleClose}
          onMovePrevRequest={handleMovePrev}
          onMoveNextRequest={handleMoveNext}
        />
      )}
    </div>
  );
}